import api from './api';
import { LeaveBalance, GrantLeaveBalanceData, RevokeLeaveBalanceData, LeaveBalanceHistory } from '../types/leaveBalance';

export const leaveBalanceService = {
  // 特定ユーザーの休暇残数取得
  async getUserBalances(userId: number): Promise<LeaveBalance[]> {
    const response = await api.get(`/leave-balances/user/${userId}`);
    return response.data;
  },

  // 全社員の休暇残数一覧取得（master のみ）
  async getCompanyBalances(): Promise<LeaveBalance[]> {
    const response = await api.get('/leave-balances/company');
    return response.data;
  },

  /**
   * 年次有給休暇管理簿（CSV）をダウンロードする（master のみ）。
   *
   * 労基則24条の7で作成が義務づけられ、3年の保存が必要な帳簿。
   * `responseType: 'blob'` にしないと axios が本文を文字列として解釈し、
   * Excel 用に付けている UTF-8 BOM が壊れる。
   */
  async downloadAnnualPaidLedger(): Promise<void> {
    const response = await api.get('/leave-balances/annual-paid-ledger', {
      responseType: 'blob',
    });

    const disposition = response.headers['content-disposition'];
    let fileName = 'annual_paid_leave_ledger.csv';
    if (disposition) {
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
      if (matches && matches[1]) {
        fileName = matches[1].replace(/['"]/g, '');
      }
    }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  // 休暇付与
  async grant(data: GrantLeaveBalanceData): Promise<any> {
    const response = await api.post('/leave-balances/grant', data);
    return response.data;
  },

  // 休暇取り消し
  async revoke(balanceId: number, data: RevokeLeaveBalanceData): Promise<any> {
    const response = await api.post(`/leave-balances/${balanceId}/revoke`, data);
    return response.data;
  },

  // 休暇履歴取得
  async getHistory(userId: number): Promise<LeaveBalanceHistory[]> {
    const response = await api.get(`/leave-balances/history/${userId}`);
    return response.data;
  },
};
